// extracted by mini-css-extract-plugin
export default {"container":"receiptDetails_container__zOZNO","row":"receiptDetails_row__ZqtPS","item":"receiptDetails_item__F-DVh","button":"receiptDetails_button__1YWdl"};